import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Shared axios instance with cookies for admin session
export const adminApi = axios.create({
  baseURL: `${API}/admin`,
  withCredentials: true,
  timeout: 30000,
});

export const publicApi = axios.create({ baseURL: API, timeout: 20000 });

export function fileUrl(fileId) {
  return `${API}/files/${fileId}`;
}
